import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
const AccountContentWrapper = ({
  isBackLinkShown = true,
  routes,
  returnPath = '',
  children
}) => /*#__PURE__*/React.createElement("div", {
  className: "account-content-wrapper"
}, /*#__PURE__*/React.createElement("div", {
  className: "container"
}, isBackLinkShown && /*#__PURE__*/React.createElement("div", {
  className: "back-to-account"
}, /*#__PURE__*/React.createElement(Link, {
  to: returnPath || routes.index.to
}, /*#__PURE__*/React.createElement("span", {
  className: "back-to-account__in"
}, I18n.t('components.AccountContentWrapper.back')))), /*#__PURE__*/React.createElement("div", null, children)));
AccountContentWrapper.propTypes = {
  children: PropTypes.node,
  returnPath: PropTypes.string,
  isBackLinkShown: PropTypes.bool,
  routes: PropTypes.object
};
export default AccountContentWrapper;